/** The side of a notification's square thumbnail, in pixels, so its loading placeholder is exactly as large. */
export const NOTIFICATION_THUMBNAIL_SIZE = 44
